class cardAssign{
    constructor( cardId, card) {
  
    
     this.cardId = cardId
     this.card = card 
     this.id = cardId
     this.name = card
    }
    static fromJson({ TarjId, Tarjeta }) {
      return new cardAssign(TarjId, Tarjeta);
    }
  }
  export default cardAssign